import { ComponentClass } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';

import { ResourceGovernanceOwnProps, ResourceGovernanceSubspace,ResourceGovernanceSubspaceDispatchProps } from './ResourceGovernanceSubspace';


const mapStateToProps: MapStateToProps<ResourceGovernanceOwnProps> = (state: AppState) => ({});
const mapDispatchToProps: MapDispatchToProps<ResourceGovernanceSubspaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents: requestSpaceContents
}, dispatch);

export const ConnectedResourceGovernanceSubspace: ComponentClass<ResourceGovernanceOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ResourceGovernanceSubspace);
